/**
 * @license Angular v21.2.13
 * (c) 2010-2026 Google LLC. https://angular.dev/
 * License: MIT
 */

const Attribute = {
  JSACTION: 'jsaction'
};

export { Attribute };

